import { Flex } from '@chakra-ui/layout';
import { CircularProgress } from '@chakra-ui/progress';
import React, { memo } from 'react';
import { DefaultTheme } from 'styled-components';

interface IProps {
  /** If it is `number`, it will be in `rem` */
  size?: number | string;
  color?: keyof DefaultTheme['colors'];
  text?: string;
}

const LoadingComponent: React.FC<IProps> = ({ size = 3, color = 500, text }) => {
  return (
    <Flex direction="column" alignItems="center" justifyContent="center" gridGap=".2rem">
      <CircularProgress
        thickness="6px"
        isIndeterminate
        color={`brand.${color}`}
        size={typeof size === 'number' ? `${size}rem` : size}
      />

      {text}
    </Flex>
  );
};

export const Loading = memo(LoadingComponent);
